import script from "./school-list.vue?vue&type=script&setup=true&lang=js"
export * from "./school-list.vue?vue&type=script&setup=true&lang=js"

import "./school-list.vue?vue&type=style&index=0&id=67bd42f1&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/map/markers/school-list.vue'],['__file',"school-list.vue"]])

export default __exports__